module.exports = __webpack_public_path__ + "img/totalmeetings10.dfe18c54.png";